<template>
    <ui-sidebar-float
        :load-text="loadText"
        :load="loading"
        name="users-add"
        title="Adicionar Usuário"
        text="Preencha corretamente os dados do novo usuário."
    >
        <div class="sidebar-content">
            <form>
                <ui-input v-model="form.data.first_name" type="text" label="Nome:" size="md" />

                <ui-input v-model="form.data.email" type="text" label="E-mail:" size="md" />

                <ui-input v-model="form.data.password" type="password" label="Senha:" size="md" />

                <ui-select-2
                    v-model="form.data.role"
                    :data="roles"
                    :multiple="false"
                    item-label="name"
                    label="Função:"
                    size="md"
                />
            </form>
            
            <div class="box-message">
                <i class="fal fa-envelope-open-text"/> <span>O usuário receberá um e-mail com os dados de acesso.</span>
            </div>
        </div>
        <template #footer>
            <ui-button type="button" design="lg success block" @click="submit"> Adicionar Usuário </ui-button>
        </template>
    </ui-sidebar-float>
</template>

<script>
	import { uiSidebarFloat } from '@/components/ui'
	import { uiSelect2, uiInput } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { user } from '@/services/axios'
	import { storage } from '@/services/storage'

	export default {
		components: {
			uiSidebarFloat,
			uiSelect2,
			uiButton,
			uiInput,
		},

		data() {
			return {
				roles: [{
					name: storage.get('label_admin'),
					value: 'admin',
					id: 1
				}, {
					name: storage.get('label_collaborator'),
					value: 'Collaborator',
					id: 2
				}],

				form: {
					data: {
						first_name: null,
						email: null,
						password: null,
						role: null,
					},
				},
				loadText: null,
				loading: false
			}
		},

		computed: {},

		created(){
			this.$root.$on('sidebar-open-users-add', () => {
				this.getGroups()
			})
		},

		methods: {
			submit() {
				this.loadText = 'Criando o usuário'
				this.loading = true
				let formData = {
					first_name: this.form.data.first_name,
					email: this.form.data.email,
					password: this.form.data.password,
					user_group: this.form.data.role.value,
				}
				user.
					create('', formData)
						.then(response => {
							if (response.data && response.data.status !== 'error') {
								if (response.data.msg) this.$toastr.s(response.data.msg)

								this.form.data = {
									first_name: null,
									email: null,
									password: null,
									role: [],
								}
							}else{
								if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
							}
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						})
						.finally(() => {
							this.$root.$emit('users-search')
							this.loading = false
						})
			},

			getGroups(){
				user
					.groups()
					.then(response => {
						if (response.data && response.data.status !== 'error') {
							let data = response.data.map(item => {
								return {
									name: item.name,
									value: item.name,
									id: item.id
								}
							})
							this.roles.push(...data)
						}else{
							if (response.data && response.data.msg) this.$toastr.e(response.data.msg)
						}
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
